import {
  Component,
  Input,
  ChangeDetectionStrategy,
  input,
  computed,
} from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { CUSTOM_ICON_PREFIX } from './icon.constants';
import { IconThemeType } from './icon.models';

@Component({
  selector: 'ui-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NzIconModule],
  template: `
    @if (iconName() !== null) {
      @if (iconProvider() === 'CUSTOM') {
        <!-- Custom icon component -->
      }
      @if (iconProvider() === 'NG_ZORRO') {
        <nz-icon
          [nzType]="iconName() || ''"
          [nzTheme]="theme()"
          [class]="'leading-none' + ' ' + class"
        />
      }
    }
  `,
})
export class IconComponent {
  protected readonly ICON_CUSTOM_PREFIX = `${CUSTOM_ICON_PREFIX}-`;

  icon = input.required<string>();
  theme = input<IconThemeType>('outline');
  iconName = computed(() => this.getIconName(this.icon()));
  iconProvider = computed(() => this.getIconProvider(this.icon()));

  @Input() viewBox: string = '';
  @Input() class: string = '';

  isCustomIcon = computed(() => this.isCustomIconName(this.icon()));
  sanitizedSvg: SafeHtml | null = null;

  constructor() {}

  private getIconName(icon: string): string {
    if (!icon) console.error('There is no icon name provided');
    return icon.startsWith(this.ICON_CUSTOM_PREFIX)
      ? this.icon().split(this.ICON_CUSTOM_PREFIX)[1]
      : icon;
  }

  private getIconProvider(icon: string): string {
    if (!icon) console.error('There is no icon name provided');
    return icon.startsWith(this.ICON_CUSTOM_PREFIX) ? 'CUSTOM' : 'NG_ZORRO';
  }

  private isCustomIconName(iconName: string): boolean {
    if (!iconName) {
      console.error('There is no icon name provided');
    }
    return iconName.startsWith(this.ICON_CUSTOM_PREFIX);
  }
}
